import React from 'react';import ReactDOM from 'react-dom/client';import App from './App';const reportWebVitals = onPerfEntry => { if (onPerfEntry && onPerfEntry instanceof Function) { import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => { getCLS(onPerfEntry); getFID(onPerfEntry); getFCP(onPerfEntry); getLCP(onPerfEntry); getTTFB(onPerfEntry); }); }};

ReactDOM.createRoot(document.getElementById('main')).render(
        <App />
); reportWebVitals();